import React, { useEffect, useState } from 'react'

import { classes } from '../../utils'

type Props = {
  currentPage: number
  setPage: (page: number) => void
  pageCount: number
  height?: number
}
export default function TablePageSelector({
  currentPage,
  setPage,
  pageCount,
  height,
}: Props) {
  const [page, setFormPage] = useState<number | undefined>(currentPage)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const parsed = parseInt(e.target.value)
    setFormPage(isNaN(parsed) ? undefined : parsed)
  }

  const handleBlur = () => {
    if (page === undefined || page < 1 || page > pageCount) {
      setFormPage(currentPage)
    }
  }

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (page !== undefined && page > 0 && page <= pageCount) {
      setPage(page)
    }
  }

  useEffect(() => {
    setFormPage(currentPage)
  }, [currentPage])

  if (pageCount === 0) {
    return null
  }

  return (
    <form
      data-testid="tablePageSelectorForm"
      className="flex h-full flex-shrink-0 items-center gap-2 px-4 text-base"
      onSubmit={handleSubmit}
      style={{ height }}
    >
      <span>Page</span>
      <input
        data-testid="tablePageSelectorInput"
        type="number"
        className={classes(
          'h-6 border-none bg-background-surface-secondary p-0 text-center text-sm outline-none [appearance:textfield] focus-visible:outline-1 focus-visible:outline-offset-[-1px] focus-visible:outline-focus-outline [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none',
          { 'w-8': pageCount < 1000 },
          { 'w-12': pageCount >= 1000 },
        )}
        value={page}
        onChange={handleChange}
        onBlur={handleBlur}
        max={pageCount}
        min={1}
      />
      <span>of {pageCount}</span>
    </form>
  )
}
